/**
 * @Author: Tolga MALKOC - ghostlexly@gmail.com
 */
import axios from 'axios';
import $ from 'jquery';
import jsForms from 'form2js';
import Vue from 'vue';
import _ from 'lodash';

let formDataToApi = {
	/**
	 *  Send Form as request and return result as promise. (use .then() to get response)
	 */
	sendForm: function (form, optionalObject = null, actionURL = null) {
		actionURL = $(form).attr('action');

		this.clearPrecedentErrors();

		if ($(form).attr('axiosMethod') === 'post' || $(form).attr('axiosMethod') === undefined) {
			let axiosConfig = {
				headers: {
					'Content-Type': 'application/json',
				},
			};

			return axios.post(actionURL, this.formToJSON(form, optionalObject), axiosConfig).then(
				res => {
					if (res.status === 200 || res.status === 201) {
						return res;
					} else {
						return this.responseErrorProcess(res);
					}
				},
				error => {
					return this.responseErrorProcess(error);
				}
			);
		} else if ($(form).attr('axiosMethod') === 'patch') {
			let axiosConfig = {
				headers: {
					'Content-Type': 'application/merge-patch+json',
				},
			};

			return axios.patch(actionURL, this.formToJSON(form, optionalObject), axiosConfig).then(
				res => {
					if (res.status === 200 || res.status === 201) {
						return res;
					} else {
						return this.responseErrorProcess(res);
					}
				},
				error => {
					return this.responseErrorProcess(error);
				}
			);
		}
	},

	clearPrecedentErrors: function () {
		// clear is-invalid classes
		$('.is-invalid').removeClass('is-invalid');
	},

	/**
	 * Processes after a request has failed
	 * */
	responseErrorProcess: function (error) {
		this.clearPrecedentErrors();

		// Write errors on form inputs
		/** violations + notification */
		if (error.response.data.violations !== undefined) {
			// --> Put violations on elements
			error.response.data.violations.forEach(item => {
				if (item.propertyPath) {
					let elements = document.querySelectorAll("[name='" + item.propertyPath + "']");

					if (elements && elements.length > 0) {
						// If invalid-feedback element doesn't exist, create it
						for (let elem of elements) {
							elem.classList.add('is-invalid');
							this.addMessageOnFormElement(elem, item.message);
						}
					}
				}
			});

			// --> Show notification message
			if (error.response.data['hydra:description']) {
				Vue.$toast.error(error.response.data['hydra:description']);
			}
			/** Only error descriptions */
		} else if (error.response.data['hydra:description']) {
			Vue.$toast.error(error.response.data['hydra:description']);
			/** default error message */
		} else {
			Vue.$toast.error('Un problème est survenu. Veuillez contacter le support technique.');
		}

		return error.response;
	},

	addMessageOnFormElement(element, message) {
		if (element.parentNode.querySelector('.invalid-feedback')) {
			element.parentNode.querySelector('.invalid-feedback').remove();
		}

		element.classList.add('is-invalid');
		let elem = document.createElement('div');
		elem.classList.add('invalid-feedback');
		elem.textContent = message;

		element.insertAdjacentElement('afterend', elem);
	},

	/**
	 * Transform a form to object JSON text.
	 */
	formToJSON: function (form, optionalObject) {
		let serializedForm = jsForms.form2js(form, '.', false); // output as object

		if (optionalObject !== null) {
			serializedForm = _.merge(serializedForm, optionalObject);
		}

		// change empty array [""] to []
		Object.keys(serializedForm).forEach(function (key, index) {
			let value = serializedForm[key];
			if (Array.isArray(value)) {
				if (value.length === 1 && value[0] === '') {
					serializedForm[key] = [];
				}
			}
		});

		return serializedForm;
	},

	/**
	 * Return form element/input by his name.
	 */
	getItemByNameFromForm: function (form, name) {
		return $(form).find("[name='" + name + "']");
	},
};

export default formDataToApi;
